<script setup>
import { Link } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'
import MultiselectInput from '@/Shared/MultiselectInput.vue'
import Portrait from '@/Shared/Portrait.vue'

const props = defineProps({
  modalities: {
    type: Array,
    required: true
  },
  players: {
    type: Array,
    required: true
  }
})

let form = useForm({
  name: '',
  modality: '',
  admins: []
})

const availableModalities = computed(() => {
  return props.modalities
})

const breadcrumbs = [{ label: 'Rankings', href: '/rankings' }, { label: 'Crear' }]

function store() {
  form.post('/rankings/store')
}
</script>

<template>
  <div class="space-y-8">
    <Portrait
      title="Crear ranking"
      subtitle="Crea un nuevo ranking para tu club"
      :breadcrumbs="breadcrumbs"
      :footer-actions="true"
    >
      <form class="bg-white rounded-lg" @submit.prevent="store">
        <div class="flex flex-wrap gap-6 p-1">
          <TextInput
            v-model="form.name"
            :error="form.errors.name"
            class="w-full lg:w-1/2"
            label="Nombre"
          />
          <SelectInput
            v-model="form.modality"
            placeholder="Elige una modalidad"
            :error="form.errors.modality"
            class="w-full lg:w-1/2"
            label="Modalidad"
          >
            <option
              v-for="modality in availableModalities"
              :key="modality.value"
              :value="modality.value"
            >
              {{ modality.name }}
            </option>
          </SelectInput>
          <MultiselectInput
            v-model="form.admins"
            :options="players"
            :error="form.errors.admins"
            class="w-full"
            label="Administradores"
            input-label="fullname"
            track-by="fullname"
          />
        </div>
      </form>

      <template #footer>
        <div class="flex items-stretch justify-end w-full space-x-4">
          <Link class="btn-white" href="/rankings">Cancelar</Link>
          <LoadingButton :loading="form.processing" class="btn-indigo" @click="store">
            Guardar
          </LoadingButton>
        </div>
      </template>
    </Portrait>
  </div>
</template>
